import { useSurveysBySubject } from './useSurveys';

/**
 * Hook for fetching CLOSED surveys for DataManagementTab
 * Filters surveys client-side by CLOSED status
 *
 * @param subjectId - Subject ID for scoping surveys
 * @returns Filtered survey data for CLOSED status
 */
export const useClosedSurveysForDataManagement = (subjectId: string) => {
  const query = useSurveysBySubject(subjectId);

  // Filter for CLOSED status surveys
  // Note: query.data is ApiResponse<SurveyDTO[]>, so query.data.data is the array
  // This matches the pattern used in useSurveysForDataManagement
  const closedSurveys = query.data?.data?.filter((survey) => survey.status === 'CLOSED') || [];

  return {
    ...query,
    data: closedSurveys,
  };
};
